// MODULES
import { useState } from "react";
import { DirectionsBike } from "@material-ui/icons";
// PROPS
import { OrderRideProps } from "./order-ride";
// IMAGES
import visaLogo from "../../assets/visa-logo.png";
import caret from "../../assets/caret-down.png";
import cardYellow from "../../assets/card-yellow.png";
import cardGreen from "../../assets/card-green.png";
// COMPONENTS
import Card from "../app/Card";
import Modal from "../app/Modal";
import PhoneNumber from "../app/PhoneNumber";

export default function RideSummary({ nextDispatchOrderPage }: OrderRideProps) {
  const [rideTypeModal, setRideTypeModal] = useState<boolean>(false);
  const [rideType, setRideType] = useState<string>("");
  const [userCountry, setUserCountry] = useState("");
  const [details, setDetails] = useState({
    mobile: "",
    password: "",
  });
  function getMobile(dialCode: string, mobile: string) {
    setUserCountry(dialCode);
    setDetails({ ...details, mobile });
  }
  return (
    <div>
      <Card header="Ride summary">
        <div>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="text-themeText">
                <DirectionsBike fontSize="large" />
              </div>
              <div>
                <h1 className="text-themeGray text-sm font-medium">Amount</h1>
                <h1 className="font-semibold text-2xl text-themeText">
                  NGN 1,200.00
                </h1>
              </div>
            </div>

            <div className="flex items-center space-x-2 bg-border/30 p-2 rounded-xl cursor-pointer">
              <div>
                <img src={visaLogo} alt="" className="w-5 h-4" />
              </div>
              <div>
                <h1 className="text-themeText font-medium">Visa</h1>
              </div>
              <div>
                <img src={caret} alt="" className="w-4 h-2" />
              </div>
            </div>
          </div>
          <div>
            <h1 className="text-lg font-semibold text-themeText my-3">Route</h1>
            <div className="flex space-x-2 ">
              <div className="text-center my-3">
                <h1>From</h1>
                <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
                <h1>To</h1>
                <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
                <h1>To</h1>
                <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
              </div>
              <div className="bg-border p-3 bg-opacity-[0.15] rounded-lg w-full">
                <h1 className="text-paragraph font-medium my-2">
                  Shomolu Lagos
                </h1>
                <div className="relative flex items-center justify-between">
                  <h1 className="my-2 text-paragraph font-medium">
                    Bola Kemi, Lagos Nigeria
                  </h1>
                  <div>
                    <div className="bg-accent w-2 h-2 flex items-center justify-center p-4 rounded-full">
                      <h1 className="font-medium">1</h1>
                    </div>
                  </div>
                </div>
                <div className="relative flex items-center justify-between">
                  <h1 className="my-2 text-paragraph font-medium">
                    24 Amani Street, Enugu Nigeria
                  </h1>
                  <div>
                    <div className="bg-accent w-2 h-2 flex items-center justify-center p-4 rounded-full">
                      <h1 className="font-medium">2</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h1 className="text-lg font-semibold text-themeText my-3">
              Ride type
            </h1>
            <div className="flex items-center justify-between">
              <div className="px-3 py-2 rounded-lg bg-themeYellow/10">
                <h1 className="font-medium text-[16px] text-themeYellow">
                  Express
                </h1>
              </div>
              <div
                onClick={() => setRideTypeModal(!rideTypeModal)}
                className="px-3 py-2 rounded-lg bg-border/10 cursor-pointer"
              >
                <h1 className="font-medium text-[16px] text-themeText">
                  Change
                </h1>
              </div>
            </div>
          </div>
          <div className="my-5 space-y-7">
            <div>
              <label htmlFor="receiverName" className="secondary-text">
                Receiver's Name
              </label>
              <div className="input-field">
                <input
                  type="text"
                  className="w-full"
                  placeholder="Enter receiver's name here"
                />
              </div>
            </div>
            <div>
              <PhoneNumber returnValues={getMobile} />
            </div>
          </div>
          <div
            className="bg-primary rounded-lg mt-10"
            onClick={nextDispatchOrderPage}
          >
            <button type="submit" className="w-full font-medium">
              Order
            </button>
          </div>
        </div>
      </Card>
      <Modal
        openModal={rideTypeModal}
        setOpenModal={() => setRideTypeModal(!rideTypeModal)}
        header="Select Mode"
      >
        <div className="space-y-8">
          <div
            style={{
              backgroundImage: `url('${cardYellow}')`,
            }}
            onClick={() => setRideType("express")}
            className={`bg-cover bg-center p-5 rounded-lg hover:cursor-pointer flex justify-between ${
              rideType === "express" && "border border-themeYellow"
            }`}
          >
            <div>
              <h1 className="font-semibold text-lg text-themeYellow">
                Express
              </h1>
              <p className="font-medium text-paragraph mt-1">
                Lorem ipsum dolor sit amet consectetur. Orci non suspendisse
                eget et.
              </p>
            </div>
            <div className="w-6 h-6 rounded-full">
              <input
                checked={rideType === "express" ? true : false}
                onChange={() => setRideType("express")}
                type="checkbox"
                className="w-full bg-white checked:bg-primary"
                id=""
              />
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url('${cardGreen}')`,
            }}
            onClick={() => setRideType("normal")}
            className={`bg-cover bg-center p-5 rounded-lg hover:cursor-pointer flex justify-between ${
              rideType === "normal" && "border border-[#27AD27]"
            }`}
          >
            <div>
              <h1 className="font-semibold text-lg text-[#27AD27]">Normal</h1>
              <p className="font-medium text-paragraph mt-1">
                Lorem ipsum dolor sit amet consectetur. Orci non suspendisse
                eget et.
              </p>
            </div>
            <div className="w-6 h-6 rounded-full">
              <input
                checked={rideType === "normal" ? true : false}
                onChange={() => setRideType("normal")}
                type="checkbox"
                className="w-full bg-white checked:bg-primary"
                id=""
              />
            </div>
          </div>
        </div>
        <div className="px-6">
          <div
            onClick={() => setRideTypeModal(!rideTypeModal)}
            className="absolute bottom-6 w-full px-6 left-0"
          >
            <button className="w-full bottom-6 font-medium">Confirm</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
